import Equipment from './Equipment'
import {Nullable} from '../../app/TypeHelpers'

export class EquipmentWithChildInfo extends Equipment {
    hasChild: boolean

    constructor(
        id: number,
        name: string,
        condominiumCd: string,
        explainText: string,
        parentEquipmentId: Nullable<number>,
        parentEquipmentName: Nullable<string>,
        reservationCountMonthly: Nullable<number>,
        reservationCountDaily: Nullable<number>,
        lotteryEntryCountMonthly: Nullable<number>,
        version: number,
        hasChild: boolean,
    ) {
        super(
            id,
            name,
            condominiumCd,
            explainText,
            parentEquipmentId,
            parentEquipmentName,
            reservationCountMonthly,
            reservationCountDaily,
            lotteryEntryCountMonthly,
            version,
        )
        this.hasChild = hasChild
    }

    static from(json: any): EquipmentWithChildInfo {
        return new EquipmentWithChildInfo(
            json.id,
            json.name,
            json.condominiumCd,
            json.explainText,
            json.parentEquipmentId,
            json.parentEquipmentName,
            json.reservationCountMonthly,
            json.reservationCountDaily,
            json.lotteryEntryCountMonthly,
            json.version,
            json.hasChild,
        )
    }
}
